export const CURRENCY_STORAGE_KEY = "currency";
export const SUPPORTED_CURRENCIES = ["BAM", "EUR", "USD", "RSD"] as const;
export type Currency = (typeof SUPPORTED_CURRENCIES)[number];
